import React, { useEffect, useState } from "react";
import SearchBar from "../../../components/searchBar";
import { useDashboardContext } from "../../../context/dashboardContext";
import { ArtistResponseDTOMin } from "../../../openapi-generated-client";

import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import Loader from "../../../components/loader";
import { useSafeNavigate } from "../../../components/unloadBlocker";
import UserVerifiedIcon from "../../../components/userVerifiedIcon";
import { getApiUrl } from "../../../data/api/apiManager";
import "./dashboardArtistsManagementPage.css";

export default function DashboardArtistsManagementPage() {

    const navigate = useSafeNavigate(useNavigate());


    const {sessionId, appContext} = useDashboardContext();
    const {artistController} = appContext;
    
    const [search, setSearch] = React.useState("");

    const [data, setData] = useState<ArtistResponseDTOMin[]>();

    async function fetchArtists() {
        setData((await artistController.getAllArtists(sessionId)).data);
    }

    useEffect(() => {
        fetchArtists();
    }, [])

    if(data == undefined) {
        return <Loader/>;
    }

    return <div className="page artist-management">
        <SearchBar search={search} onSearch={setSearch}/>
        <Button onClick={() => navigate("/dashboard/admin/artists/create")}>Create Artist</Button>
        <div className="artist-list">
            {data.map(artist => <div key={artist.id} className="artist-item" onClick={() => {
                navigate("/dashboard/admin/artists/" + artist.id);
            }}>
                <img className="profile-picture" src={getApiUrl("assets/by-hash/" + artist.profilePicture)}/>
                <h3>{artist.name}</h3>
                <UserVerifiedIcon artist={{
                    verified: artist.verified,
                    noUser: artist.noUser
                }}/>
            </div>)}
        </div>
    </div>
}